module.exports = __webpack_public_path__ + "static/media/myvideo.07bb978.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myvideo.mp3
// module id = BNYa
// module chunks = 10